<template>
  <v-container class="fill-height">
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4 xl2 offset-xl5>
        <v-card class="login-card">
          <loading-indicator></loading-indicator>
          <v-layout class="text-center mb-5">
            <v-flex xs12>
              <h1 class="pt-5">Sign In</h1>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-form>
              <v-text-field v-model="user.email" label="Email"></v-text-field>
              <v-text-field v-model="user.password" label="Password" :append-icon="show ? 'visibility' : 'visibility_off'" :type="show ? 'text' : 'password'" @click:append="show = !show"></v-text-field>
              <div v-if="this.loginError != null" class="text-center error--text mt-3 mb-5 error-message">{{loginError}}</div>
              <v-btn block depressed large @click="login" color="accent">Login</v-btn>
              <v-btn block text @click="forgotPassword" class="mt-5">Forgot Password?</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LoadingIndicator from '@/components/_layouts/LoadingIndicator'
export default {
  name: 'Login',
  created () {
    this.authClear()
  },
  data: () => ({
    user: {
      email: null,
      password: null
    },
    show: false
  }),
  components: {
    LoadingIndicator
  },
  methods: {
    ...mapActions({
      authClear: 'auth/clearAuth'
    }),

    login () {
      this.$store.dispatch('auth/login', this.user)
    },
    forgotPassword () {
      this.$router.push('/forgot')
    }
  },
  computed: {
    ...mapGetters({
      loginError: 'auth/error'
    })
  }
}
</script>

<style scoped>
  .login-card {
    margin-top: 100px;
    padding: 0 20px 20px 20px;
  }
  .error-message {
    height: 20px;
    font-weight: bold;
  }
  @media only screen and (max-width: 350px) {
    .login-card {
      margin-top: 70px;
    }
  }
</style>
